'use client';

import { createContext, useContext } from 'react';

export interface RetouchFlowContextValue {
  /**
   * Misnomer kept for the Add-to-Cart handlers that call it: aliased to
   * `resetModalState` in index.tsx, it does NOT reset any visit count.
   */
  resetCounter: () => void;
  /** UserAnalytics `ringVisits`, passed through. */
  visitCount: number;
}

// Non-throwing default so consumers rendered outside the provider stay alive.
const defaultContextValue: RetouchFlowContextValue = {
  resetCounter: () => {
    console.warn(
      '[RetouchFlow] resetCounter called outside of RetouchFlowProvider',
    );
  },
  visitCount: 0,
};

export const RetouchFlowContext =
  createContext<RetouchFlowContextValue>(defaultContextValue);

export const useRetouchFlowContext = (): RetouchFlowContextValue =>
  useContext(RetouchFlowContext);

export default RetouchFlowContext;
